import { useEffect } from 'react';
import useRenderStatus from 'modules/OperatorReports/api/useRenderStatus';

// Renderless poller — one per tracked job. Lives at the app root (inside
// BackgroundJobsProvider) so it keeps polling render-status even after the
// report page unmounts. Because useRenderStatus is keyed by
// (reportId, slot, inputHash), this shares ONE underlying request with any
// in-page hook for the same render (react-query dedup) — no double polling.
export default function JobStatusPoller({ job, onStatus }) {
  const poll = useRenderStatus(job.reportId, job.slot, job.inputHash, { enabled: true });
  const data = poll.data;

  useEffect(() => {
    if (data) onStatus(job.key, data);
  }, [data, job.key, onStatus]);

  return null;
}
